<template>
    <div>
        <b-card v-if="isLoaded"> 
            <div class="table-responsive mt-3">
                <table class="table table-hover" style="table-layout: fixed; font-size: 0.875em">
                    <thead>
                    <tr>
                        <th>{{$t('dataTypeHasUnitPrice')}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="dataType in dataTypes" @click="routeToUnitPriceDetail(dataType)" style="cursor: pointer;">
                        <td style="color: #007bff;">{{getDataTypeName(dataType.name)}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </b-card>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    name: 'UnitPrice',
    data() {
        return {
            isLoaded: false,
            tags: [],
            dataTypes: [],
            dataTypesWithPrice: []
        };
    },
    methods: {
        getDataTypeName(dataTypeName) {
            return this.$t(dataTypeName);
        },
        routeToUnitPriceDetail(dataType) {
            this.$router.push({
                name: 'admin-unit-price-detail',
                params: {type_id: dataType.id}
            });
            return Promise.resolve();
        },
        getDataTypesWithPrice() {
            this.isLoaded = false;
            this.$Progress.start();
            return this.axios.get('/dataTypes/withPrice').then(({data}) => {
                this.dataTypes = _.filter(this.$store.state.dataTypes, function(o) {
                    return _.includes(data, o.id);
                });
                this.isLoaded = true;
                this.$Progress.finish();
            });
        },
        init() {
            this.getDataTypesWithPrice();
        }
    },
    created() {
        this.init();
    }
};
</script>

<style lang="scss" scoped>
</style>

<i18n src="../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "dataType": "Veri Tipi",
            "emissionType": "Emisyon Tipi",
            "date": "Son değişme tarihi",
            "dataTypeHasUnitPrice": "Birim Fiyatı Olan Veri Tipleri"
        },
        "en": {
            "dataType": "Data Type",
            "emissionType": "Emission Type",
            "date": "Last Updated Date",
            "dataTypeHasUnitPrice": "Data Types Have an Unit Price"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Setting/UnitPrice.vue